import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFollowUpRequest,
  clearFollowUp,
  getFollowUpByIdRequest,
  clearFollowUpById,
} from '../../../redux/FollowUp/followupSlice';
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { CiEdit } from 'react-icons/ci';

const resolveCreatedBy = (item) => {
  const createdBy = item?.createdBy;
  const createdByUser = item?.createdByUser;
  const fromCreatedBy = Array.isArray(createdBy) ? createdBy[0] : createdBy;
  const fromCreatedByUser = Array.isArray(createdByUser)
    ? createdByUser[0]
    : createdByUser;
  const source =
    (fromCreatedBy && typeof fromCreatedBy === 'object' && fromCreatedBy) ||
    (fromCreatedByUser && typeof fromCreatedByUser === 'object' && fromCreatedByUser) ||
    {};

  return {
    userId:
      source._id || (typeof createdBy === 'string' ? createdBy : undefined),
    userName:
      source.name ||
      source.fullName ||
      source.userName ||
      item?.userName ||
      item?.name ||
      '-',
  };
};

const formatFollowupNotes = (notes) => {
  const items = Array.isArray(notes) ? [...notes] : notes ? [notes] : [];
  return items
    .sort((a, b) => (Number(b?.createdAt) || 0) - (Number(a?.createdAt) || 0))
    .map((item) => {
      if (typeof item === 'string') {
        return { text: item, time: '', userName: '-' };
      }
      const { userId, userName } = resolveCreatedBy(item);
      return {
        text: item?.note || '',
        time: item?.createdAt
          ? new Date(item.createdAt).toLocaleString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })
          : '',
        userId,
        userName,
      };
    })
    .filter((item) => item.text);
};

const FollowupList = ({ leadID, onEdit }) => {
  const dispatch = useDispatch();
  const [openNotesDialog, setOpenNotesDialog] = useState(false);
  const [selectedNotesItem, setSelectedNotesItem] = useState(null);

  const {
    followUp = [],
    loading,
    error,
    followUpById,
    followUpByIdLoading,
  } = useSelector(
    (state) => state.followUp || { followUp: [], loading: false, error: null },
  );
  const { instalaxmiAdmin = [] } = useSelector(
    (state) => state.tickets || {},
  );
  

  useEffect(() => {
    if (leadID) {
      dispatch(getFollowUpRequest(leadID));
    } else {
      dispatch(clearFollowUp());
    }
  }, [dispatch, leadID]);

  if (loading) return <p>Loading...</p>;
  // if (error) return <p style={{ color: "red" }}>{error}</p>;

  const selectedNotes = formatFollowupNotes(
    followUpById?.Notes ||
      followUpById?.notes ||
      selectedNotesItem?.Notes ||
      selectedNotesItem?.notes,
  ).map((note) => {
    if (note.userName && note.userName !== '-') return note;
    const matched = instalaxmiAdmin.find((user) => user._id === note.userId);
    return { ...note, userName: matched?.name || '-' };
  });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px',
      }}
    >
      {followUp.length > 0 ? (
        followUp.map((item) => (
          <Card
            key={item._id || Math.random()}
            sx={{
              borderRadius: '12px',
              boxShadow: '0px 2px 10px rgba(0,0,0,0.15)',
              width: '100%',
              borderTop: `6px solid ${
                item.status === 'completed'
                  ? '#1fb11f'
                  : item.status === 'in-progress'
                    ? 'rgba(234, 219, 18, 1)'
                    : item.status === 'pending'
                      ? '#F8D7DA'
                      : item.status === 'closed'
                        ? '#f61124ff'
                        : item.status === 'hold'
                          ? '#d7953d'
                          : '#ada7a7ff' // default gray
              }`,
            }}
          >
            {' '}
            <CardActions sx={{ justifyContent: 'end' }}>
              <IconButton onClick={() => onEdit(item)} size="small">
                <CiEdit />
              </IconButton>{' '}
            </CardActions>
            <CardContent>
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: '#7028DA' }}
              >
                {typeof item.title === 'object'
                  ? JSON.stringify(item.title)
                  : item.title || '-'}
              </Typography>
              <div style={{ display: 'flex' }}>
                <Box sx={{ width: '20%' }}>
                  <Typography fontWeight={600}>AssignTo:</Typography>
                  <Typography>
                    {item.assignTo?.name
                      ? item.assignTo.name
                      : JSON.stringify(item.assignTo) || '-'}
                  </Typography>
                </Box>
                <Box sx={{ width: '20%' }}>
                  <Typography fontWeight={600}>Comment:</Typography>
                  <Typography>
                    {typeof item.comment === 'string'
                      ? item.comment || '-'
                      : item?.comment?.[0]?.comment ||
                        item?.comment?.comment ||
                        '-'}
                  </Typography>
                </Box>
                <Box sx={{ width: '20%' }}>
                  <Typography fontWeight={600}>Notes:</Typography>
                  <button
                    style={{
                      backgroundColor: '#ffc107',
                      color: '#000',
                      border: 'none',
                      padding: '5px 10px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      marginTop: '4px',
                    }}
                    onClick={() => {
                      setSelectedNotesItem(item);
                      setOpenNotesDialog(true);
                      if (item?._id) {
                        dispatch(getFollowUpByIdRequest(item._id));
                      }
                    }}
                  >
                    {formatFollowupNotes(item.Notes).length > 0
                      ? `View (${formatFollowupNotes(item.Notes).length})`
                      : 'View'}
                  </button>
                </Box>
                <Box sx={{ width: '20%' }}>
                  <Typography fontWeight={600}> Follow-up Date:</Typography>
                  <Typography>
                    {item.followupDate
                      ? new Date(item.followupDate).toLocaleDateString('en-IN')
                      : '-'}{' '}
                  </Typography>
                </Box>
                <Box sx={{ width: '20%' }}>
                  <Typography fontWeight={600}>Created By User:</Typography>
                  <Typography>
                    {item.createdByUser?.[0]?.name || '-'}
                  </Typography>
                </Box>
                <Box sx={{ width: '20%' }}>
                  <Typography fontWeight={600}>Status:</Typography>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      padding: '4px 12px',
                      borderRadius: '6px',
                      width: '130px',
                      fontSize: '0.875rem',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      color: '#fff',
                      backgroundColor:
                        item.status === 'completed'
                          ? '#1fb11f'
                          : item.status === 'in-progress'
                            ? 'rgba(234, 219, 18, 1)'
                            : item.status === 'pending'
                              ? '#F8D7DA'
                              : item.status === 'closed'
                                ? '#f61124ff'
                                : item.status === 'hold'
                                  ? '#d7953d'
                                  : '#ada7a7ff',
                    }}
                  >
                    {item.status || '-'}
                  </Box>
                </Box>
              </div>
            </CardContent>
          </Card>
        ))
      ) : (
        <Typography>No follow-ups found.</Typography>
      )}
      <Dialog
        open={openNotesDialog}
        onClose={() => {
          setOpenNotesDialog(false);
          setSelectedNotesItem(null);
          dispatch(clearFollowUpById());
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
            color: '#fff',
          }}
        >
          Notes
          {selectedNotesItem?.title ? ` — ${selectedNotesItem.title}` : ''}
        </DialogTitle>
        <DialogContent dividers>
          {followUpByIdLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
              <CircularProgress size={28} />
            </Box>
          ) : selectedNotes.length === 0 ? (
            <Typography color="text.secondary">No notes</Typography>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {selectedNotes.map((item, idx) => (
                <Box
                  key={item.userId ? `${item.userId}-${idx}` : idx}
                  sx={{
                    p: 1.75,
                    borderRadius: '10px',
                    border: '1px solid #E5E7EB',
                    background: '#F9FAFB',
                  }}
                >
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: '#6B7280' }}
                  >
                    {item.userName && item.userName !== '-'
                      ? `${item.userName}${item.time ? ` • ${item.time}` : ''}`
                      : item.time || '-'}
                  </Typography>
                  <Typography sx={{ mt: 0.5, fontSize: 14, color: '#111827' }}>
                    {item.text}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenNotesDialog(false);
              setSelectedNotesItem(null);
              dispatch(clearFollowUpById());
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FollowupList;
